module.exports = __webpack_public_path__ + "img/pizza_tomato_sauce.ad4c0169.jpg";